import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-white mb-4">韩漫在线</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              高清韩漫，畅享阅读。我们致力于提供最优质的韩国漫画在线阅读体验，覆盖爱情、奇幻、动作等多种类型，免费下拉式阅读，随时随地畅读您喜爱的作品。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">漫画分类</h3>
            <ul className="flex flex-col gap-2">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">快速链接</h3>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">联系我们</h3>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                contact@manhuaonline.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-phone-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                400-888-0000
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                北京市朝阳区望京SOHO
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2024-2026 韩漫在线 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-background-400">
            本站所有漫画内容均来自合作方授权，仅供在线阅读
          </p>
        </div>
      </div>
    </footer>
  );
}